module.exports = __webpack_public_path__ + "images/emoji/scissors.d000fa033e83a15e4407.png";